import { clearLoginData } from "core/storage/localStorage";

const LogoutPage = ({ history }) => {
  clearLoginData(null);
  history.push("/login");
  return "";
};

export default LogoutPage;
